import { TUserDetailsResponse } from "../types/User.type";
import { RouteType } from "./config";

const hasRole = (user: TUserDetailsResponse, route: RouteType) =>
    !route.allowedRoles || route.allowedRoles.includes(user?.role);

const hasPermissions = (user: TUserDetailsResponse, route: RouteType) =>
    !route.requiredPermissions ||
    route.requiredPermissions.every(p => user?.permissions?.includes(p));

export const canAccessRoute = (user: TUserDetailsResponse, route: RouteType) =>
    hasRole(user, route) && hasPermissions(user, route);
